import { apiVariable } from "./apiVariable";
import {
  TruckRouteFuelRequest,
  TruckRouteFuelResult,
} from "../interfaces/Operations/truckRouteFuel";

export async function compareTruckRoutes(
  token: string,
  request: TruckRouteFuelRequest,
  signal: AbortSignal,
): Promise<TruckRouteFuelResult> {
  const response = await fetch(`${apiVariable}/truck-route-fuel-options`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(request),
    signal,
  });
  const result = await response.json();
  if (!response.ok)
    throw new Error(
      result?.message ?? "Unable to calculate truck routes. Please retry.",
    );
  if (
    !Array.isArray(result?.routes) ||
    !Array.isArray(result?.warnings) ||
    !Array.isArray(result?.missingInputs)
  )
    throw new Error("Unexpected route response. Please retry.");
  return result;
}
